import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { DriverAssignLink } from '../utils/DriverAssignLink';

/**
 * Sends the pre-TF-20797 path to the transport access URL with its query intact.
 *
 * Not the route table's redirectTo: Angular 16 builds the target query from the redirect's own
 * parameters, dropping every one of them. Not navigate-then-return-false either: that cancels the
 * guard's own navigation along with the one it rejected, leaving a blank page.
 */
@Injectable({
  providedIn: 'root',
})
export class LegacyDriverAssignRedirectGuard {
  constructor(private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): UrlTree {
    return this.router.createUrlTree([DriverAssignLink.PATH], { queryParams: route.queryParams });
  }
}
